module.exports = __webpack_public_path__ + "27f95b153547921c7cd98674f8426222.MP3";